import { EnvironmentProviders, Provider } from '@angular/core';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { LanguageInterceptor } from './interceptors/language.interceptor';

export const languageProviders: Array<Provider | EnvironmentProviders> = [
  { provide: HTTP_INTERCEPTORS, useClass: LanguageInterceptor, multi: true},
]
